var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-overlay',{staticStyle:{"z-index":"9999"},attrs:{"value":_vm.loading}},[_c('v-progress-circular',{attrs:{"size":64,"color":"#2196f3","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }